import React from 'react';
import { useGameStore } from '../store/gameStore';
import { CheckCircle, AlertTriangle, Info, XCircle } from 'lucide-react';
import clsx from 'clsx';

export const FeedbackOverlay: React.FC = () => {
  const feedback = useGameStore(state => state.feedback);

  return (
    <div className="fixed top-24 left-1/2 -translate-x-1/2 z-[100] flex flex-col gap-2 pointer-events-none w-full max-w-md items-center">
      {feedback.map(msg => (
        <div 
          key={msg.id}
          className={clsx(
            "flex items-center gap-3 px-6 py-3 rounded-full shadow-[0_0_20px_rgba(0,0,0,0.5)] backdrop-blur-xl border animate-pop-in transition-all duration-300",
            msg.type === 'success' ? "bg-green-500/20 border-green-500/50 text-green-100 shadow-green-500/20" :
            msg.type === 'error' ? "bg-red-500/20 border-red-500/50 text-red-100 shadow-red-500/20" :
            msg.type === 'warning' ? "bg-yellow-500/20 border-yellow-500/50 text-yellow-100 shadow-yellow-500/20" :
            "bg-blue-500/20 border-blue-500/50 text-blue-100 shadow-blue-500/20"
          )}
        >
          {msg.type === 'success' && <CheckCircle className="w-5 h-5 shrink-0" />}
          {msg.type === 'error' && <XCircle className="w-5 h-5 shrink-0" />}
          {msg.type === 'warning' && <AlertTriangle className="w-5 h-5 shrink-0" />}
          {msg.type === 'info' && <Info className="w-5 h-5 shrink-0" />}
          <span className="font-bold tracking-wide text-sm">{msg.message}</span>
        </div>
      ))}
    </div>
  );
};
